import { crudMdActions } from "@/services/crud-md-actions";

const name = "business-groups";

export default {
  name,
  ...crudMdActions(name),
};
